export default __webpack_public_path__ + "static/media/food-and-drink.inline.917d991e.svg";